import React from 'react';
import { Camera, Cloud, Compass, Image, Mail, MessageSquare, Music, Phone, Settings } from 'lucide-react';
const VEXU_LOGO = 'https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg';
interface AppIcon {
  name: string;
  icon: React.ElementType;
  tile: string;
  color: string;
}
const APPS: AppIcon[][] = [[{
  name: 'Messages',
  icon: MessageSquare,
  tile: 'bg-[#4CD964]',
  color: 'text-white'
}, {
  name: 'Mail',
  icon: Mail,
  tile: 'bg-[#2F9BFF]',
  color: 'text-white'
}, {
  name: 'Photos',
  icon: Image,
  tile: 'bg-white',
  color: 'text-[#F5A623]'
}, {
  name: 'Camera',
  icon: Camera,
  tile: 'bg-[#3A3A3C]',
  color: 'text-white'
}], [{
  name: 'Weather',
  icon: Cloud,
  tile: 'bg-[#3E9BF0]',
  color: 'text-white'
}, {
  name: 'Maps',
  icon: Compass,
  tile: 'bg-[#E8F2E4]',
  color: 'text-[#3C9A57]'
}, {
  name: 'Music',
  icon: Music,
  tile: 'bg-[#FA3C4C]',
  color: 'text-white'
}, {
  name: 'Settings',
  icon: Settings,
  tile: 'bg-[#8E8E93]',
  color: 'text-white'
}]];

/**
 * A neutral phone home screen used as the "before you open Vexu" state in
 * presentations. Not part of the Vexu product — it only sets the stage for a
 * system notification arriving.
 */
export function IosHomeScreen() {
  return <div className="h-full w-full select-none" style={{
    background: 'linear-gradient(180deg, #E8EFE9 0%, #DCE7DE 45%, #CFDDD3 100%)'
  }} aria-hidden="true" data-id="element-209" data-mp="2sgoxhq1abbkt">
      <div className="px-7 pt-6 space-y-7" data-id="element-210" data-mp="3p4lfmzcdeey5">
        {APPS.map((row, i) => <div key={i} className="grid grid-cols-4 gap-x-5" data-id="element-211" data-mp="3p6ph7amsr1v9" data-mpi={i}>
            {row.map(app => {
          const Icon = app.icon;
          return <div key={app.name} className="flex flex-col items-center" data-id="element-212" data-mp="3fe0asu63se6s">
                  <div className={`grid h-[58px] w-[58px] place-items-center rounded-[15px] shadow-sm shadow-black/10 ${app.tile}`} data-id="element-213" data-mp="6z8eb9armzjl">
                    <Icon className={`h-7 w-7 ${app.color}`} strokeWidth={1.8} data-id="element-214" data-mp="brjemd9f4nco" />
                  </div>
                  <span className="mt-1.5 text-[10.5px] font-medium text-[#28352C]" data-id="element-215" data-mp="ljcil4z85v17">
                    {app.name}
                  </span>
                </div>;
        })}
          </div>)}

        {/* Vexu, sitting alongside everything else */}
        <div className="grid grid-cols-4 gap-x-5" data-id="element-216" data-mp="7lea2g7l4stm">
          <div className="flex flex-col items-center" data-id="element-217" data-mp="2nco9niryfeg">
            <div className="grid h-[58px] w-[58px] place-items-center rounded-[15px] bg-white shadow-sm shadow-black/10" data-id="element-218" data-mp="2o4c2c64r8u6">
              <img src={VEXU_LOGO} alt="" className="h-9 w-9 object-contain" data-id="element-219" data-mp="3pzwvzocmlwa1" />
            </div>
            <span className="mt-1.5 text-[10.5px] font-medium text-[#28352C]" data-id="element-220" data-mp="3pxj5lssw588t">
              Vexu
            </span>
          </div>
        </div>
      </div>

      {/* Dock */}
      <div className="absolute bottom-6 left-4 right-4 rounded-[26px] bg-white/45 px-4 py-3 backdrop-blur-xl" data-id="element-221" data-mp="3g0xtyomd8yw0">
        <div className="grid grid-cols-4 gap-x-5" data-id="element-222" data-mp="3b4pjvpn0zvvp">
          {[{
          name: 'Phone',
          icon: Phone,
          tile: 'bg-[#4CD964]',
          color: 'text-white'
        }, {
          name: 'Mail',
          icon: Mail,
          tile: 'bg-[#2F9BFF]',
          color: 'text-white'
        }, {
          name: 'Music',
          icon: Music,
          tile: 'bg-[#FA3C4C]',
          color: 'text-white'
        }, {
          name: 'Maps',
          icon: Compass,
          tile: 'bg-[#E8F2E4]',
          color: 'text-[#3C9A57]'
        }].map(app => {
          const Icon = app.icon;
          return <div key={app.name} className={`grid h-[54px] w-[54px] place-items-center justify-self-center rounded-[14px] shadow-sm shadow-black/10 ${app.tile}`} data-id="element-223" data-mp="2i6ddlwqzvy5f">
                <Icon className={`h-7 w-7 ${app.color}`} strokeWidth={1.8} data-id="element-224" data-mp="2wx47dac5d7b6" />
              </div>;
        })}
        </div>
      </div>
    </div>;
}